import React, { forwardRef } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const Ferret = forwardRef<SVGSVGElement, SvgIconProps>(
  function Ferret(props, ref) {
    return (
      <SvgIcon ref={ref} {...props}>
        <path d="M8.714 12.156c0 .683-1.025.683-1.025 0s1.025-.683 1.025 0M16.14 12.156c0 .683-1.025.683-1.025 0s1.025-.683 1.025 0" />
        <path d="M21.09 4.484c-1.044-.52-2.012-.622-2.875-.3-.9.334-1.443 1.046-1.701 1.476-1.373-.585-2.935-.9-4.56-.9-1.626 0-3.188.315-4.56.9-.26-.43-.802-1.142-1.702-1.477-.864-.32-1.832-.22-2.877.3-1.045.52-1.756 1.746-1.811 3.12-.061 1.493.657 2.864 1.928 3.71a5.132 5.132 0 0 0-.054.714c0 1.379.657 2.679 1.818 3.732-.271.112-.552.24-.839.386a.446.446 0 0 0 .405.795c.437-.223.857-.399 1.249-.538.47.323.997.612 1.574.86a14.677 14.677 0 0 0-1.96 2.312.446.446 0 0 0 .735.505c.68-.992 1.38-1.737 1.916-2.239.77 1.316 2.369 2.165 4.176 2.165 1.855 0 3.49-.894 4.235-2.268.548.5 1.3 1.28 2.028 2.342a.444.444 0 0 0 .62.114.446.446 0 0 0 .115-.62 14.634 14.634 0 0 0-2.014-2.362 9.21 9.21 0 0 0 1.516-.85c.423.146.883.334 1.362.579a.445.445 0 0 0 .405-.795c-.33-.168-.65-.31-.957-.434 1.129-1.044 1.765-2.326 1.765-3.684 0-.219-.019-.46-.054-.713 1.27-.847 1.989-2.217 1.93-3.71-.057-1.375-.767-2.6-1.812-3.12Z" />
        <path
          d="M14.714 8.851c-1.067 0-2.064.316-2.8.876-.734-.561-1.731-.876-2.799-.876-2.173 0-3.943 1.34-3.943 2.986 0 1.166.86 2.2 2.242 2.696a.445.445 0 0 0 .502-.146c.693-.89 1.965-1.5 3.402-1.632.395-.035.8-.035 1.193 0 1.437.131 2.708.741 3.402 1.632a.442.442 0 0 0 .502.147c1.383-.497 2.242-1.53 2.242-2.697 0-1.647-1.77-2.986-3.944-2.986ZM11.996 15c.553 0 1.004.503 1.004.84 0 .337-.44 1.16-.992 1.16-.553 0-1.008-.823-1.008-1.16 0-.337.444-.84.996-.84Z"
          fill="#FFF"
        />
        <path d="m12 17-2 1M12 17l2 1" stroke="#FFF" />
        <path
          d="M1.396 2.793A1.39 1.39 0 0 1 0 1.396C0 .62.62 0 1.396 0c.776 0 1.396.62 1.396 1.397.026.776-.62 1.396-1.396 1.396Z"
          fill="#3C3838"
          transform="translate(7 10)"
        />
        <path
          d="M1.396 2.793A1.39 1.39 0 0 1 0 1.396C0 .62.62 0 1.396 0c.776 0 1.396.62 1.396 1.397.026.776-.62 1.396-1.396 1.396Z"
          fill="#3C3838"
          transform="translate(14.2 10)"
        />
        <circle
          cx="1.5"
          cy="1.5"
          fill="#FFF"
          r="1"
          transform="translate(14 10)"
        />
        <circle
          cx="1.5"
          cy="1.5"
          fill="#FFF"
          r="1"
          transform="translate(7 10)"
        />
      </SvgIcon>
    )
  },
)

export default Ferret
